import React from 'react';
import { useSelector } from 'react-redux';
import {
  NavLink,
  Navigate,
  Route,
  Routes,
  useLocation,
} from 'react-router-dom';
import { Box, Drawer, List } from '@mui/material';
import { Loader, MenuItem } from 'components';
import { accountItems } from 'components/account/AccountMenuItems';
import BusinessAccountEntry from 'components/account/BusinessAccountEntry';
import AccountInformation from './modules/AccountInformation';
import Payment from './modules/Payment';
import Alerts from './modules/Alerts';
import FavoritePageContainer from './modules/FavoritePageContainer';
import ClaimedPage from './modules/ClaimedPage';
import ClaimSnapshotPage from './modules/ClaimSnapshotPage';
import LogoSrc from 'components/Logo/Logo.png';
import { useIsMobile } from 'utils/UI';
import { useBusinessUser } from 'utils/roles';
import { Helmet } from 'react-helmet-async';
import { currentPageUrl, loginUrl } from 'utils/loginRedirect';

const Account = () => {
  const isMobile = useIsMobile();
  const location = useLocation();
  const user = useSelector((state) => state.user);
  const businessUser = useBusinessUser();

  if (user.isFetching) {
    return <Loader />;
  }

  if (!user.details?.userId) {
    return <Navigate to={loginUrl(currentPageUrl(location))} replace />;
  }

  return (
    <>
      <Helmet>
        <title>My profile - HiddenUnderGround</title>
      </Helmet>
      {!isMobile && (
        <Drawer
          variant="permanent"
          anchor="left"
          sx={{ '& .MuiDrawer-paper': { display: 'flex', flexDirection: 'column', width: 300, boxSizing: 'border-box' } }}
        >
          <Box pt={6} pb={4} width={300} display="flex" justifyContent="center">
            <NavLink to="/">
              <img src={LogoSrc} alt="" height={62} />
            </NavLink>
          </Box>
          <List sx={{ '& .MuiTypography-root': { color: 'black !important' } }}>
            {accountItems.map(({ label, path, Icon }) => (
              <MenuItem
                icon={<Icon sx={{ color: 'black' }} />}
                text={label}
                link={path}
                key={path}
              />
            ))}
          </List>
          <List sx={{ mt: 'auto', pb: 6, flexShrink: 0 }}>
            <BusinessAccountEntry />
          </List>
        </Drawer>
      )}
      <Routes>
        {/* Default route for /account */}
        <Route index element={<Alerts />} />

        {/* Other routes */}
        <Route path="my-alerts" element={<Alerts />} />
        <Route path="my-favorites" element={<FavoritePageContainer />} />
        <Route path="claimed" element={<ClaimedPage />} />
        <Route path="claimed/:claimId/snapshot" element={<ClaimSnapshotPage />} />
        {businessUser && <Route path="payment" element={<Payment />} />}
        <Route path="my-information" element={<AccountInformation />} />

        {/* Redirect to /account/my-alerts if no route matches */}
        <Route path="*" element={<Navigate to="/account/my-alerts" replace />} />
      </Routes>
    </>
  );
};

export default Account;
